import { memo } from 'react';
import { Text, Heading } from '@library';
import StoryblokResponsiveImage from '../../../content/components/PageComponents/StoryblokResponsiveImage';
import styles from './SaleTile.module.scss';

const SaleTile = ({
    content,
}: {
    content: {
        image: {
            filename: string;
            title: string;
            focus: string;
            alt: string;
        };
        link_target: string;
        title: string;
        description: string;
    };
}) => {
    return (
        <div className={styles.container}>
            <div className={styles.saleBanner}>
                <StoryblokResponsiveImage
                    className={styles.image}
                    image={content.image}
                    predefinedSet="fullWidth"
                    predefinedDefaultHeight={400}
                    onlyFocusCrop
                />
            </div>

            <div className={styles.infoContainer}>
                <a className={styles.title} href={content.link_target}>
                    <Heading h3 bold>
                        {content.title}
                    </Heading>
                </a>
                <div className={styles.description}>
                    <Text uppercase tertiary medium>
                        {content.description}
                    </Text>
                </div>
            </div>
        </div>
    );
};

export default memo(SaleTile);
